import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuButton, MenuList, MenuItem, Button, Box, useColorModeValue } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { normalizeSiteLanguage, SiteLanguage } from '../i18n/language';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPathLocale, localeForLanguage, pathForLocale } from '../i18n/localizedRoutes';

const LanguageSelector: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  
  const changeLanguage = (language: SiteLanguage) => {
    if (getPathLocale(location.pathname)) {
      navigate(pathForLocale(location.pathname, localeForLanguage(language)) + location.search + location.hash);
    } else {
      // Account and payment flows change language without changing their URL.
      void i18n.changeLanguage(language);
    }
  };

  const currentLanguage = normalizeSiteLanguage(
    i18n.resolvedLanguage || i18n.language,
  );
  const currentLanguageLabel = {
    en: t('languageSelector.english'),
    zh: t('languageSelector.traditionalChinese'),
    'zh-CN': t('languageSelector.simplifiedChinese'),
  }[currentLanguage];
  
  // Responsive styling
  const buttonColor = useColorModeValue('gray.700', 'white');
  const buttonHoverBg = useColorModeValue('gray.100', 'whiteAlpha.200');
  const menuListBg = useColorModeValue('white', '#23272F');
  const menuListBorderColor = useColorModeValue('gray.200', '#3C4354');
  const menuItemHoverBg = useColorModeValue('gray.100', 'whiteAlpha.100');
  const menuItemSelectedBg = useColorModeValue('gray.200', 'whiteAlpha.200');
  
  return (
    <Box ml={2}>
      <Menu>
        <MenuButton 
          as={Button} 
          rightIcon={<ChevronDownIcon />} 
          variant="ghost" 
          color={buttonColor}
          _hover={{ bg: buttonHoverBg }}
          size="sm"
        >
          {currentLanguageLabel}
        </MenuButton>
        <MenuList bg={menuListBg} borderColor={menuListBorderColor}>
          <MenuItem 
            onClick={() => changeLanguage('en')}
            bg={currentLanguage === 'en' ? menuItemSelectedBg : "transparent"}
            _hover={{ bg: menuItemHoverBg }}
            color={buttonColor}
          >
            {t('languageSelector.english')}
          </MenuItem>
          <MenuItem 
            onClick={() => changeLanguage('zh')}
            bg={currentLanguage === 'zh' ? menuItemSelectedBg : "transparent"}
            _hover={{ bg: menuItemHoverBg }}
            color={buttonColor}
          >
            {t('languageSelector.traditionalChinese')}
          </MenuItem>
          <MenuItem
            onClick={() => changeLanguage('zh-CN')}
            bg={currentLanguage === 'zh-CN' ? menuItemSelectedBg : "transparent"}
            _hover={{ bg: menuItemHoverBg }}
            color={buttonColor}
          >
            {t('languageSelector.simplifiedChinese')}
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
}

export default LanguageSelector;

